import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createSlots as _createSlots, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/filter.svg'
import _imports_1 from '@/assets/images/no-items.png'


const _hoisted_1 = { class: "default-filter-wrap" }
const _hoisted_2 = { class: "filter-fields" }
const _hoisted_3 = { class: "grid guter-change" }
const _hoisted_4 = { class: "AdvanceSearchAction" }
const _hoisted_5 = {
  key: 1,
  class: "selected-filter-wrap"
}
const _hoisted_6 = { class: "selectedfilter" }
const _hoisted_7 = { class: "Remove" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "admin-actions-btn-wrapper mt-0 mb-0"
}
const _hoisted_10 = { class: "left-part" }
const _hoisted_11 = { class: "right-part" }
const _hoisted_12 = { class: "common__Table" }
const _hoisted_13 = { class: "grid guter-change" }
const _hoisted_14 = { class: "p-dialog-footer" }
const _hoisted_15 = { class: "msgPopup" }
const _hoisted_16 = { class: "m-0 mb-3" }
const _hoisted_17 = { class: "field-checkbox mb-0" }
const _hoisted_18 = { class: "p-dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ((!$setup.Props.IsOnlyGrid && !$setup.Props.hideNotificationReadBtn && !$setup.Props.hideFilter))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass($props.AdvSearchBtnClass)
        }, [
          ($setup.Props.IsShowFilterBox)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["filter-wrapper", { active: $setup.lazyParams.filters.length>0 }])
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _renderSlot(_ctx.$slots, "basicfilter")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_Button, {
                      class: "p-button-secondary mr-2",
                      icon: "pi pi-search",
                      label: "Search",
                      onClick: $setup.ApplyFilter
                    }, null, 8 /* PROPS */, ["onClick"]),
                    _createVNode(_component_Button, {
                      class: "p-button-aux",
                      icon: "pi pi-refresh",
                      onClick: $setup.clearFilterItems,
                      label: "Clear All"
                    }, null, 8 /* PROPS */, ["onClick"])
                  ])
                ]),
                ($setup.Props.IsAdvFilter)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-aux popup-filter-btn",
                      onClick: _withModifiers($setup.OpenAdvanceSearchModel, ["prevent"])
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("img", { src: _imports_0 }, null, -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]))
                  : _createCommentVNode("v-if", true),
                ($setup.lazyParams.filters.filter(x=>x.searchType=='Filter').length>0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _cache[9] || (_cache[9] = _createElementVNode("h5", null, "Filters", -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lazyParams.filters.filter(x=>x.searchType=='Filter'), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "selectedfilterItems",
                            key: item.fieldName
                          }, [
                            _createElementVNode("span", null, _toDisplayString($setup.IsNullEmptyOrUndefined(item.fieldDisplayName)?item.fieldName:item.fieldDisplayName), 1 /* TEXT */),
                            _createElementVNode("strong", null, _toDisplayString($setup.IsNullEmptyOrUndefined(item.fieldDisplayValue)?item.fieldValue:item.fieldDisplayValue), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_7, [
                              _createElementVNode("i", {
                                class: "pi pi-times",
                                onClick: ($event: any) => ($setup.removeFilterItems(item.fieldName))
                              }, null, 8 /* PROPS */, _hoisted_8)
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (!$setup.Props.IsOnlyGrid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            ($props.hideExportBtn)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "btn p-button-aux",
                  label: "Export All",
                  onClick: $setup.ExportExcel
                }, null, 8 /* PROPS */, ["onClick"])), [
                  [_vShow, $setup.resultData.length>0]
                ])
              : _createCommentVNode("v-if", true),
            ($props.hideMultiDispatch)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "btn p-button-aux ml-1",
                  label: "Bulk Dispatch"+"("+$setup.selectedRecords.length+")",
                  onClick: $setup.multiDispacth
                }, null, 8 /* PROPS */, ["label"])), [
                  [_vShow, $setup.selectedRecords.length>1]
                ])
              : _createCommentVNode("v-if", true),
            ($setup.selectedRecords.length && $setup.Props.hideDeletBtn && $props.hideMultiDispatch != true)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  class: "btn p-button-aux ml-1",
                  label: "Delete",
                  onClick: $setup.Removeconfirm
                }))
              : _createCommentVNode("v-if", true),
            ($setup.selectedRecords.length)
              ? _renderSlot(_ctx.$slots, "left-part-button", {}, undefined, undefined, 3)
              : _createCommentVNode("v-if", true),
            _renderSlot(_ctx.$slots, "extraDOM")
          ]),
          _createElementVNode("div", _hoisted_11, [
            _renderSlot(_ctx.$slots, "right-buttons")
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", {
        class: _normalizeClass(["scroll_height", { active: $setup.lazyParams.filters.length>0 && !$setup.Props.IsOnlyGrid}])
      }, [
        _createVNode($setup["DataTable"], {
          ref: "dt",
          value: $setup.resultData,
          selection: $setup.selectedRecords,
          "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedRecords) = $event)),
          lazy: true,
          paginator: true,
          rows: $props.NumnerOfRow,
          totalRecords: $setup.totalRows,
          loading: $setup.loading,
          onPage: _cache[1] || (_cache[1] = ($event: any) => ($setup.onPage($event))),
          onSort: _cache[2] || (_cache[2] = ($event: any) => ($setup.onSort($event))),
          class: "p-datatable-customers",
          filterDisplay: "menu",
          paginatorTemplate: $props.paginatorTemplate,
          currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
          rowsPerPageOptions: [15, 30, 50, 100],
          responsiveLayout: $setup.responsiveLayoutValue,
          onRowSelect: $setup.onRowSelect,
          onRowUnselect: $setup.onRowSelect,
          onRowSelectAll: _ctx.onRowSelectAll,
          onRowUnSelectAll: _ctx.onRowSelectAll,
          scrollHeight: $props.IsscrollHeight,
          showGridlines: "",
          onRowDblclick: $setup.onRowDubleClick,
          resizableColumns: $props.resizableColumns,
          columnResizeMode: $props.columnResizeMode,
          selectionMode: $props.selectionMode
        }, _createSlots({
          empty: _withCtx(() => [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "no-data" }, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "No Data Found"
              }),
              _createElementVNode("h4", null, "No Record Found")
            ], -1 /* CACHED */))
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "columns")
          ]),
          _: 2 /* DYNAMIC */
        }, [
          ($props.showFooter)
            ? {
                name: "footer",
                fn: _withCtx(() => [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "table_footer" }, [
                    _createElementVNode("div", { class: "tf_right" })
                  ], -1 /* CACHED */))
                ]),
                key: "0"
              }
            : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "selection", "rows", "totalRecords", "loading", "paginatorTemplate", "responsiveLayout", "onRowSelect", "onRowUnselect", "onRowSelectAll", "onRowUnSelectAll", "scrollHeight", "onRowDblclick", "resizableColumns", "columnResizeMode", "selectionMode"])
      ], 2 /* CLASS */)
    ]),
    _createVNode(_component_Dialog, {
      class: "large-modal AdvanceFiltersDialog",
      header: "Advance Search",
      visible: $setup.AdvanceSearchModel,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (($setup.AdvanceSearchModel) = $event)),
      modal: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _renderSlot(_ctx.$slots, "advancefilter")
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[12] || (_cache[12] = _createElementVNode("div", null, null, -1 /* CACHED */)),
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              icon: "pi pi-refresh",
              label: "Clear All",
              class: "p-button-aux",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.clearFilterItems()))
            }),
            _createVNode(_component_Button, {
              icon: "pi pi-plus-circle",
              label: "Add Filters",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.ApplyFilter($event, true))),
              autofocus: ""
            })
          ])
        ])
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["visible"]),
    _createVNode(_component_Dialog, {
      header: "Remove Confirmation",
      visible: $setup.RemoveConfirmation,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (($setup.RemoveConfirmation) = $event)),
      modal: true,
      onHide: $setup.CancelEvent
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("p", _hoisted_16, [
            _cache[13] || (_cache[13] = _createTextVNode("Do you want to ", -1 /* CACHED */)),
            _createElementVNode("strong", null, "Remove " + _toDisplayString($setup.selectedRecords.length) + " Records?", 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Checkbox, {
              inputId: "Checkbox",
              name: "Checkbox",
              value: "Checkbox",
              modelValue: $setup.RemoveRecords,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.RemoveRecords) = $event))
            }, null, 8 /* PROPS */, ["modelValue"]),
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "Checkbox" }, "Confirm that I want to Remove.", -1 /* CACHED */))
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[15] || (_cache[15] = _createElementVNode("div", null, null, -1 /* CACHED */)),
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              label: "Cancel",
              onClick: $setup.CancelEvent,
              class: "p-button-aux mr-2"
            }),
            _createVNode(_component_Button, {
              position: "bottom-right",
              label: "Remove",
              onClick: $setup.Remove,
              class: "p-button-primary",
              autofocus: "",
              disabled: !$setup.RemoveRecords || !$setup.RemoveRecords.length
            }, null, 8 /* PROPS */, ["disabled"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"])
  ], 64 /* STABLE_FRAGMENT */))
}